require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-canada-in-a-day.json") })
        }
      }, "path---projects-canada-in-a-day");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-canada-in-a-day!./.cache/json/projects-canada-in-a-day.json
// module id = 514
// module chunks = 231608221292675